import { Invoice } from '../../domain/entities/Invoice';
import { InvoiceRepository } from '../../domain/repositories/InvoiceRepository';

/**
 * Implementación mock del repositorio de facturas para desarrollo y pruebas
 */
export class MockInvoiceRepository implements InvoiceRepository {
  private invoices: Invoice[] = [
    {
      id: '1',
      invoiceNumber: '001',
      clientName: 'Empresa ABC S.A.S',
      clientId: '900123456-7',
      totalAmount: 1500000,
      total:1000000,
      paymentInterest:500000,
      issueDate: '2025-01-15',
      dueDate: '2025-02-15',
      status: 'pending',
      description: 'Comisión por servicios fiduciarios - Enero 2025',
      fideicomiso: 'FID001',
      office: 'Oficina Principal',
      prefijo: 'FAC',
      numeroFactura: '001',
      fechaFactura: '2025-01-15',
      secuencialDetalle: '001'
    },
    {
      id: '2',
      invoiceNumber: '002',
      clientName: 'Corporación XYZ',
      clientId: '800987654-3',
      totalAmount: 2750000,
      total:1000000,
      paymentInterest:500000,
      issueDate: '2025-01-20',
      dueDate: '2025-02-20',
      status: 'pending',
      description: 'Comisión por administración fiduciaria - Enero 2025',
      fideicomiso: 'FID002',
      office: 'Oficina Principal',
      prefijo: 'FAC',
      numeroFactura: '002',
      fechaFactura: '2025-01-20',
      secuencialDetalle: '002'
    },
    {
      id: '3',
      invoiceNumber: '003',
      clientName: 'Inversiones 123 Ltda.',
      clientId: '860543210-9',
      totalAmount: 950000,
      total:1000000,
      paymentInterest:500000,
      issueDate: '2025-01-10',
      dueDate: '2025-02-10',
      status: 'overdue',
      description: 'Comisión por gestión fiduciaria - Enero 2025',
      fideicomiso: 'FID003',
      office: 'Oficina Principal',
      prefijo: 'FAC',
      numeroFactura: '003',
      fechaFactura: '2025-01-10',
      secuencialDetalle: '003'
    }
  ];

  /**
   * Busca una factura por su número
   * @param invoiceNumber - Número de la factura a buscar
   * @returns Promesa que resuelve a la factura si se encuentra, o null si no existe
   */
  async findByInvoiceNumber(invoiceNumber: string): Promise<Invoice | null> {
    // Simulamos un pequeño retraso para emular una petición de red
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const invoice = this.invoices.find(inv => inv.invoiceNumber === invoiceNumber);
    return invoice || null;
  }

  /**
   * Obtiene todas las facturas
   * @returns Promesa que resuelve a un array de facturas
   */
  async getAll(): Promise<Invoice[]> {
    // Simulamos un pequeño retraso para emular una petición de red
    await new Promise(resolve => setTimeout(resolve, 500));
    
    return [...this.invoices];
  }

  /**
   * Actualiza una factura existente
   * @param updatedInvoice - Factura actualizada
   * @returns Promesa que resuelve a la factura actualizada
   */
  async update(updatedInvoice: Invoice): Promise<Invoice> {
    // Simulamos un pequeño retraso para emular una petición de red
    await new Promise(resolve => setTimeout(resolve, 400));
    
    const index = this.invoices.findIndex(inv => inv.id === updatedInvoice.id);
    
    if (index === -1) {
      throw new Error(`Factura con ID ${updatedInvoice.id} no encontrada`);
    }
    
    this.invoices[index] = { ...updatedInvoice };
    return this.invoices[index];
  }
}